var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseSingletonService, Singleton } from '~/services/service.base';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { MobxQuery } from '~/tools/mobx.query';
import { api } from '~/tools/api';
import { EApiUrl } from '~/tools/api/types';
import { plainToInstance } from 'class-transformer';
import { ModelShelve } from '~/models';
export let ServiceShelve = class ServiceShelve extends BaseSingletonService {
    shelves = observable.array([]);
    constructor() {
        super();
        makeObservable(this);
    }
    getShelves(communityId, params) {
        return new MobxQuery({
            queryFn: (() => api
                .get(`${EApiUrl.communities}/${communityId}/${EApiUrl.shelves}`, {
                params,
            })
                .then(response => {
                runInAction(() => this.shelves.replace(plainToInstance(ModelShelve, response.data)));
            })),
        }).query();
    }
};
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], ServiceShelve.prototype, "getShelves", null);
ServiceShelve = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [])
], ServiceShelve);
